import { render, staticRenderFns } from "./ViewDatabaseUserDialog.vue?vue&type=template&id=3cc0900d&"
import script from "./ViewDatabaseUserDialog.vue?vue&type=script&lang=ts&"
export * from "./ViewDatabaseUserDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports